import { classnames } from 'Utils/classnames/classnames.utils';
import React from 'react';
import { t } from 'Src/i18n';
type ContactProps = {
  className?: string;
  secondaryText: string;
  text: string;
  url?: string;
};

const Contact = ({ text, secondaryText, className, url }: ContactProps) => {
  const Comp = url ? 'a' : 'div';
  const link = url
    ? {
        href: url,
      }
    : undefined;
  return (
    <Comp className={className} {...link}>
      <div className="text-center text-sienna lg:text-end">
        <p className="text-18 font-bold">{text}</p>
        <p
          className={classnames('text-14', {
            underline: !url,
          })}
        >
          {secondaryText}
        </p>
      </div>
    </Comp>
  );
};

export const CallCenterBlock = () => (
  <div className="flex flex-col justify-between gap-20 bg-pearl p-20 lg:flex-row">
    <div className="lg:text-initial text-center">
      <p className="text-18 font-bold text-sienna">{t('navigationBar.contact.title')}</p>
      <p className="text-14">{t('remote.noResult.contactAdvisors')}</p>
    </div>
    <Contact
      secondaryText={t('navigationBar.contact.toll')}
      text={t('navigationBar.contact.phoneNumber')}
      url={`tel:${t('navigationBar.contact.phoneNumber')}`}
    />
  </div>
);
